<template>
  <g>
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12 19.8001C17.8767 19.8001 22.8 17.0307 22.8 13.2001C22.8 9.36951 17.8767 6.6001 12 6.6001C6.1234 6.6001 1.20001 9.36951 1.20001 13.2001C1.20001 17.0307 6.1234 19.8001 12 19.8001ZM12 9.0001C16.7273 9.0001 20.4 11.066 20.4 13.2001C20.4 15.3342 16.7273 17.4001 12 17.4001C7.27276 17.4001 3.60001 15.3342 3.60001 13.2001C3.60001 11.066 7.27276 9.0001 12 9.0001Z"
    />
    <path
      d="M11 5C11 4.44772 11.4477 4 12 4C12.5523 4 13 4.44772 13 5V8C13 8.55228 12.5523 9 12 9C11.4477 9 11 8.55228 11 8V5Z"
    />
    <path
      d="M15.7466 5.53736C15.9708 5.09288 16.6346 4.91604 17.2292 5.14232C17.8239 5.36863 18.1242 5.91241 17.9 6.35688L16.8653 8.40871C16.6411 8.85319 15.9774 9.03006 15.3827 8.80375C14.788 8.57744 14.4877 8.03367 14.7118 7.58919L15.7466 5.53736Z"
    />
    <path
      d="M8.2138 5.32371C7.99342 4.83759 7.31141 4.62024 6.69051 4.83822C6.0696 5.05621 5.7449 5.62701 5.96528 6.11311L6.98263 8.35718C7.203 8.84329 7.88502 9.06066 8.50593 8.84267C9.12684 8.62468 9.45153 8.05389 9.23115 7.56777L8.2138 5.32371Z"
    />
    <path
      d="M2.64032 6.80009C2.09168 6.56521 1.38233 6.8209 1.05594 7.37117C0.72955 7.92144 0.909722 8.55792 1.45837 8.79279L4.35464 10.0327C4.9033 10.2675 5.61265 10.0118 5.93904 9.46158C6.26542 8.9113 6.08524 8.27482 5.53659 8.03995L2.64032 6.80009Z"
    />
    <path
      d="M20.9484 6.68132C21.4196 6.35334 22.0951 6.46532 22.4574 6.93149C22.8197 7.39765 22.7315 8.04146 22.2603 8.36944L19.7731 10.1009C19.302 10.429 18.6263 10.317 18.264 9.85079C17.9018 9.38466 17.9901 8.74085 18.4612 8.41283L20.9484 6.68132Z"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12 16.7999C14.3196 16.7999 16.2 14.9195 16.2 12.5999C16.2 10.2803 14.3196 8.3999 12 8.3999C9.68039 8.3999 7.79999 10.2803 7.79999 12.5999C7.79999 14.9195 9.68039 16.7999 12 16.7999ZM12 10.7999C12.9941 10.7999 13.8 11.6058 13.8 12.5999C13.8 13.594 12.9941 14.3999 12 14.3999C11.0059 14.3999 10.2 13.594 10.2 12.5999C10.2 11.6058 11.0059 10.7999 12 10.7999Z"
    />
  </g>
</template>
